import { render, staticRenderFns } from "./PortfolioDashboard.vue?vue&type=template&id=5e52e496&scoped=true&"
import script from "./PortfolioDashboard.vue?vue&type=script&lang=js&"
export * from "./PortfolioDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e52e496",
  null
  
)

export default component.exports